import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { fetchInfoFromVersionColor, sendCotizacion } from '../../actions';
import Cotizar, { CotizarConfirmation } from '../../components/Cotizar';
import useVersion from '../../utils/hooks/useVersion';
import useCar from '../../utils/hooks/useCar';

const CotizarContainer = ({ isConfirmation }) => {
  const dispatch = useDispatch();
  const { version, tipo, modelo, anio, color } = useParams();
  const { logoUrl, car, isLoading, coupon, descuentoWeb } = useSelector(state => ({
    coupon: state.personalization.coupon,
    logoUrl: state.personalization.data?.logoUrl,
    car: state.personalization.data || {},
    isLoading: state.personalization.isLoading,
    state,
    descuentoWeb: state.personalization?.additional?.descuentoWeb
  }));
  useEffect(() => {
    const carCode = car?.codigo;
    if (carCode === version) return;
    dispatch(fetchInfoFromVersionColor(tipo, modelo, version, anio));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { version: currentVersion, hasActivePromo } = useVersion();
  const {
    cuota,
    selectedBank,
    plazo,
    selectedPrime,
  } = useCar(currentVersion);

  const sendCotizacionRequest = cotizacion => {
    let financiamiento = '';
    if (!selectedBank) {
      financiamiento = 'no se escogio ninguna entidad financiera.';
    } else {
      cotizacion.banco = selectedBank?.post_type;
      cotizacion.interes = hasActivePromo ? 18 : selectedBank.interes;
      cotizacion.plazo = plazo;
      cotizacion.prima = selectedPrime;
      financiamiento = `Banco: ${selectedBank?.post_type}; Cuota: ${cuota.toFixed(2)}; Interes: ${hasActivePromo ? 18 : selectedBank.interes}; Plazo: ${plazo} meses; Prima: ${selectedPrime} %`;
    }
    if (car.descuentoAplicado) {
      cotizacion.cuponRecordId = coupon?.data?.quickbaseCodigoRecorId;
      cotizacion.montoCupon = currentVersion?.descuentoGerencia;
    }
    if (car.descuentoWebAplicado) {
      cotizacion.descuentoWeb = true;
      cotizacion.descuentoWebMonto = descuentoWeb.monto;
      cotizacion.origen = "DESCUENTO WEB";
    }
    cotizacion.cuota = cuota.toFixed(2);
    cotizacion.financiamiento = financiamiento;
    cotizacion.esconderTasa = false;
    dispatch(sendCotizacion(tipo, modelo, version, anio, color, cotizacion));
  }

  if (isConfirmation) {
    return <CotizarConfirmation 
      logoUrl={logoUrl} 
      car={car} isLoading={isLoading} 
    />
  }

  return <Cotizar 
    logoUrl={logoUrl} 
    car={car} isLoading={isLoading} 
    sendCotizacionRequest={sendCotizacionRequest} 
  />;
};

export default CotizarContainer;
